import '../../styles/erro.css'
import Btn from '../../components/BotaoFlutuante'

function index() {
  return (
    <>
      <Btn />
      <h1 className='ErroText' >PAGE NOT FOUND</h1>
    </>
  );
}
export default index